import { NewExclusionListController } from '../controller/NewExclusionListController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { NewExclusionListEvents } from '../types';

export class NewExclusionListWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: NewExclusionListController,
    });
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }
    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', '');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  get isList(): boolean {
    return this.hasAttribute('data-listId');
  }

  set listId(value: string | undefined) {
    if (typeof value === 'undefined') {
      this.removeAttribute('data-listId');
    } else {
      this.setAttribute('data-listId', value);
    }
    this.dispatchEvent(new Event(NewExclusionListEvents.SET_LIST_ID));
  }

  get listId(): string | undefined {
    if (this.hasAttribute('data-listId')) {
      const value = this.getAttribute('data-listId');
      return value ? value : '';
    }
    return undefined;
  }
}
